import {useContext} from "react"
import {TeamContext} from "../contexts/TeamContext"

export function useTeamContext() {
    const context = useContext(TeamContext)
    if (!context) {
        throw new Error("useTeamContext must be used within a TeamProvider")
    }
    return context
}